import { BaseReducer } from '@hobs/utils/baseReducer';
import { QUERY } from '@hobs/constants/locations';

class Locations extends BaseReducer {
  static defaultState = {
    query: []
  };
  constructor() {
    super(Locations.defaultState);

    this.actionMap = {
      [QUERY.SUCCESS]: this.addQueryResults
    };
  }

  addQueryResults = (state, action) => {
    return Object.assign({}, state, { query: action.query });
  };
}
export default new Locations().reducer;
